// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"66586":"8c029cfeea","83763":"33353af58b"}[chunkId] + ".css";
};